export default "__VITE_ASSET__B4LG2k81__"